<template>
  <section class="cloning-overlay">
    <div v-if="isCloning" class="flex items-center justify-center h-full text-center">
      <div>
        <h3>{{item.name}}</h3>
        <p>Is Being cloned</p>
        <i class="far fa-spinner-third fa-spin" />
      </div>
    </div>

    <div v-else>
      <header class="flex items-start justify-between">
        <div>
          <h3>{{item.name}}</h3>
          <p>{{cloneMessage}}</p>
        </div>
        <div class="cursor-pointer teal-hover" @click="$emit('close')">
          <i class="far fa-times-circle"/>
        </div>
      </header>

      <form>
        <p v-if="cloningError" class="error-msgs">{{ cloningError }}</p>
      </form>

      <form-renderer
          id="clone-form"
          :model.sync="model"
          :fields.sync="formFields"
          :fieldsAdditions="formFieldsAdditions"
          :showMessageNotifications="false"
          submitButtonLabel="booleanSearch.clone_and_save"
          :submitButtonClass="`button button-save no-line-height ${isTagSearch && 'm10'}`"
          :formElementClass="`${!isTagSearch && 'flex'} items-end justify-start`"
          formWrapperClass="flex-grow mr10"
          @onSave="submit"
          @updateModel="(value, field) => updateModel(value, field)"
      />

    </div>
  </section>
</template>

<script>
// Plugins
import { mapState ,mapActions } from 'vuex'

// Mixins
import storeHelper from "../../../../mixins/boolean-search/storeHelper";

// Components
import FormRenderer from '../../../form-renderer';
import i18n from '../../../../i18n';

export default {
  name: "CloneOverlay",

  props: {
    item: {
      type: Object,
      required: true
    },
    resourceName: {
      type: String,
      required: true
    }
  },

  mixins: [ storeHelper ],

  data() {
    return {
      model: { name: '', projectId: null, clientId: null }
    }
  },

  computed: {

    ...mapState({
      project_id: state => state.booleanSearch.project_id,
      isCloning: state => state.booleanSearch.isCloning,
      projects: state => state.booleanSearch.projects,
      clients: state => state.booleanSearch.clients,
      cloningError: state => state.booleanSearch.clonedError
    }),

    projectsData() { return this.projects.data },
    clientsData() { return this.clients.data },
    isBusy() { return this.projects.isBusy },
    isGroup() { return ['group_library', 'group'].indexOf(this.resourceName) !== -1 },
    isTagSearch() { return ['tag_library', 'tagSearch'].indexOf(this.resourceName) !== -1 },
    cloneMessage() {
      return this.isGroup ? i18n.t('booleanSearch.clone_into_client_message') : i18n.t('booleanSearch.clone_into_project_message');
    },
    formFields() {
      if(this.isGroup) {
        return ["boolCloneName", "boolClientId"];
      }
      else {
        return ["boolCloneName", "boolProjectId"];
      }
    },
    formFieldsAdditions() {
      return {
        boolCloneName: {
          placeholder: this.isGroup ? i18n.t('booleanSearch.cloned_placeholder_group')
            : this.isTagSearch
            ? i18n.t('booleanSearch.cloned_placeholder_tagSearch')
            : i18n.t('booleanSearch.cloned_placeholder'),
          customClass: "mb10"
        },
        boolClientId: {
          options: this.clientsData,
          onSearchChange: (name) => {
            this.searchClients(name);
          }
        },
        boolProjectId: {
          options: this.projectsData,
          onSearchChange: (name) => {
            this.searchProjects(name);
          }
        }
      };
    }
  },

  methods: {
    ...mapActions({
      getProjects : "booleanSearch/getPaginatedResource",
      getClients  : "booleanSearch/getPaginatedResource"
    }),
    searchProjects(value) {
      if(!value && this.model.projectId) return
      this.setFilterParam('projects', 'query', value)
      this.resetPagination('projects')
      this.getProjects({key: 'projects', url: `projects/${this.project_id}/search`})
    },
    searchClients(value) {
      if(!value && this.model.clientId) return
      this.setFilterParam('clients', 'query', value)
      this.resetPagination('clients')
      this.getClients({key: 'clients', url: `clients`})
    },
    submit() {
      const cloneToId = this.isGroup ? this.model.clientId : this.model.projectId;
      this.$emit('cloneResource', this.model.name, this.item.id, cloneToId, this.resourceName)
    },
    updateModel(newValue, field) {
      if(!field) return;
      this.model[field.name] = newValue[field.name];
    }
  },
  components: {
    FormRenderer
  }
}
</script>